import { Check, CircleAlert, Download, X } from "lucide-react";
import { useEffect, useState } from "react";
import UiButton from "../Buttons/UiButton";
import { registerToastEmitter, ToastPayload } from "./toast";

type ToastItem = ToastPayload & {
  id: number;
};

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    registerToastEmitter((toast) => {
      if (!toast?.message?.trim()) return;
      const id = Date.now();
      setToasts((prev) => [...prev, { ...toast, id }]);

      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 4000);
    });
  }, []);

  return (
    <div className="fixed flex flex-col gap-4 justify-center items-center top-4 left-1/2 -translate-x-1/2 z-[9999] p-1 ">
      {toasts.map((toast) => {
        const config = {
          success: {
            icon: <Check className="h-4 w-4 text-white" />,
            color: "bg-green-500",
          },
          error: {
            icon: <CircleAlert className="h-4 w-4 text-white " />,
            color: "bg-red-500",
          },
          info: {
            icon: <span className="text-white font-bold">i</span>,
            color: "bg-blue-500",
          },
          warning: {
            icon: <span className="text-white font-bold">!</span>,
            color: "bg-orange-500",
          },
        }[toast.type || "success"];

        return (
          <div
            key={toast.id}
            className="relative w-[380px] overflow-hidden rounded-xl bg-white border border-gray-100 shadow-lg p-2 flex gap-3"
          >
            {/* ICON */}
            <div
              className={`flex items-center h-4 w-4 justify-center rounded-full ${config.color}`}
            >
              {config.icon}
            </div>

            {/* CONTENT */}
            <div className="flex-1">
              <p className="text-xs font-semibold text-gray-800">
                {toast?.message}
              </p>

              {toast.actionText && toast.onAction && (
                <div className="mt-2">
                  <UiButton
                    text={toast.actionText}
                    buttonType="secondary"
                    icon={<Download className="size-4" />}
                    onClick={toast.onAction}
                  />
                </div>
              )}
            </div>

            {/* CLOSE */}
            <button
              type="button"
              onClick={() =>
                setToasts((prev) => prev.filter((t) => t.id !== toast.id))
              }
              className="text-gray-400 hover:text-gray-600 hover:bg-offWhite hover:rounded-full p-1"
            >
              <X className="h-4 w-4" />
            </button>
            <div className="absolute bottom-0 left-0 h-[3px] w-full bg-gray-100">
              <div className={`h-full ${config.color} toast-progress`} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
